<cas-button (clickAction)="sendStatusUpdateRequest()" [btnText]="'Update Cellular Device Status'"></cas-button>
